/**
 * @generated SignedSource<<231f9a4649440571180547ab99096a0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScheduleListTabContainer_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleListTab_user">;
  readonly " $fragmentType": "ScheduleListTabContainer_user";
};
export type ScheduleListTabContainer_user = ScheduleListTabContainer_user$data;
export type ScheduleListTabContainer_user$key = {
  readonly " $data"?: ScheduleListTabContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleListTabContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ScheduleListTabContainer_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleListTab_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "cd4fc674d52e9e73783b6895140c5982";

export default node;
